import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import { Button } from "../../common/Button/Button";
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";

export default function ESPReportsModal(props) {
    return (
        <Modal
        isOpen={props.isOpen}
        onRequestClose={props.toggleModal}
        ariaHideApp={false}
    >
        <ModalContent className="ESP-reports-modal">
            {props.isLoadingReports && <Spinner className="center" />}
            <div className="p-2 modal-header-bar">
                <span>Download Reports</span>
                <button
                    id="espreportsClose"
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={props.toggleModal}
                >
                    <X style={{ pointerEvents: "none" }} color="white" />
                </button>
            </div>
            <div
                className={`modal-body ${props.isDisabled} ${props.isLoadingReports && "set-opacity"}`}
            >
                <div className='form-group'>
                    <div>
                        <b>
                            <span>All Services in Progression </span>
                        </b><br></br>(Sample File Name: ServicesInSPM-13Oct18-11.xlsx)
                        <br></br>
                        <div className="inline-margin-ESP-reports-modal" style={{marginTop:"10px"}}>
                            <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={props.ASPfromDate}
                                onChange={(date) =>props.setASPfromDate(date)}
                                placeholderText="Progression From Date"
                            />
                            <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={props.ASPtoDate}
                                onChange={(date) =>props.setASPtoDate(date)}
                                placeholderText="Progression To Date"
                            />
                            <div>
                            <Button className="inline-button float-right" onClick={props.fetchAllServicesReport}>Generate</Button>
                            </div>
                        </div>
                    </div>
                    <div style={{clear:"both"}}></div>
                    <br></br>
                    <div>
                        <b>
                            <span>Service Requests to Fullfilment</span>
                        </b><br></br>(Sample File Name: ReqToFulfillment-13Oct18-12.xlsx)
                        <br></br>
                        <div className="inline-margin-ESP-reports-modal" style={{marginTop:"10px"}}>
                            <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={props.SRFfromDate}
                                onChange={(date) =>props.setSRFfromDate(date)}
                                placeholderText="SR Requested From Date"
                            />
                            <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={props.SRFtoDate}
                                onChange={(date) =>props.setSRFtoDate(date)}
                                placeholderText="SR Requested To Date"
                            />
                            <div>
                            <Button className="inline-button float-right" onClick={props.fetchFullfillmentReport}>Generate</Button>
                            </div>
                        </div>
                    </div>
                    <div style={{clear:"both"}}></div>
                    <br></br>
                    <div>
                        <b>
                            <span>SMS Report</span>
                        </b><br></br>(Sample File Name: SMS Report -18Aug10-49.xlsx)
                        <div className="inline-margin-ESP-reports-modal">
                            <div>
                                <Button className="inline-button float-right" onClick={props.fetchSMSTrailReport}>Generate</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ModalContent>
    </Modal >
    );
  }